// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-8cbb4b52] .custom-radio {\r\n  margin-bottom: 20px;\n}\n[data-v-8cbb4b52] .custom-radio .custom-control-label {\r\n  font-weight: 700;\n}\n[data-v-8cbb4b52]\r\n  .custom-control-input:disabled:checked\r\n  ~ .custom-control-label::before {\r\n  background-color: #3f5b60 !important;\r\n  border-color: #3f5b60 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
